import { useGetGenericUiConfig } from "~/modules/dtwin/composables/useGetGenericUiConfig";
import type { DynamicUI } from "~/modules/dtwin/models/DynamicUI.interface";
import type { DynamicUIDetail } from "~/modules/dtwin/models/DynamicUIDetail.interface";
import { mergeUIConfig } from "~/modules/dtwin/utils/mergeUIConfig";

const { getGenericUiConfig } = useGetGenericUiConfig();

export function getMergedOrGenericUIConfig(
  properties?: DynamicUI,
): DynamicUI | undefined {
  let uiConfigProperties: DynamicUI | undefined = properties;
  const genericUIConfig = getGenericUiConfig();
  const genericColumns = genericUIConfig.list.columns;
  const modelColumns = uiConfigProperties?.list?.columns;
  if (modelColumns && modelColumns?.length > 0) {
    uiConfigProperties!.list.columns = mergeUIConfig(
      genericColumns,
      modelColumns,
    );
  } else if (uiConfigProperties?.list) {
    uiConfigProperties.list.columns = genericColumns;
  } else if (uiConfigProperties) {
    uiConfigProperties.list = { columns: genericColumns };
  } else {
    uiConfigProperties = genericUIConfig;
  }

  // remove hidden columns
  uiConfigProperties.list.columns = uiConfigProperties.list.columns.filter(
    (column) => !column.hide,
  );

  mergeDetailKey("description", uiConfigProperties);
  mergeDetailKey("firmware", uiConfigProperties);
  mergeDetailKey("certificate", uiConfigProperties);

  return uiConfigProperties;
}

function mergeDetailKey(
  key: "description" | "firmware" | "certificate",
  uiConfigProperties?: DynamicUI,
) {
  const genericUIConfig = getGenericUiConfig();
  const genericDescription: DynamicUIDetail[] = genericUIConfig.details
    ? genericUIConfig.details[key] || []
    : [];
  const modelDescription = uiConfigProperties?.details
    ? uiConfigProperties?.details[key] || []
    : [];
  if (modelDescription && modelDescription?.length > 0) {
    uiConfigProperties!.details[key] = mergeUIConfig(
      genericDescription,
      modelDescription,
    );
  } else if (uiConfigProperties?.details) {
    uiConfigProperties.details[key] = genericDescription;
  } else if (uiConfigProperties) {
    uiConfigProperties.details = {
      description: [],
    };
    uiConfigProperties.details[key] = genericDescription;
  }

  // remove hidden fields
  uiConfigProperties.details[key] = uiConfigProperties.details[key].filter(
    (field) => !field.hide,
  );

  return uiConfigProperties;
}
